import React, { useEffect, useRef, useState } from "react";
import "../Header/header.css";

import { useAuth } from "../../context/AuthContext";
/* Logos (ne pas changer) */
import amenLogo from "../../images/Log1.png";
import mgLogo from "../../images/MG.png";
import { Link, useNavigate, useLocation } from "react-router-dom";
/* IcÃ´nes PNG fournis (dans /images) */
import iconUser from "../../images/Group 1321316032.png";
import iconAide from "../../images/Group 1321316031.png";

import iconProducts from "../../images/Group 1321316029.png";
import { FaHome } from "react-icons/fa";
import { useBrand } from "../../context/brand-context";
import { useSelector } from "react-redux";
import { selectCartItems } from "../../context/MyCartSlice";
export default function Header() {
  const { brand, setBrand } = useBrand();
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const cartCount = useSelector(selectCartItems).reduce((a, it) => a + Number(it.qty || 0), 0);
  const [openUser, setOpenUser] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const userRef = useRef(null);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
const scrollToSection = (sectionId) => {
    const doScroll = () => {
      const el = document.getElementById(sectionId);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    };

    if (location.pathname === "/espace") {
      doScroll();
    } else {
      navigate("/espace", { replace: false });
      setTimeout(doScroll, 0); // Petit délai pour laisser le temps à la page Home de charger
    }
  };
  const scrollToProducts = () => {
    const doScroll = () => {
      const el = document.getElementById("products-section");
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    };

    // Si je suis déjà sur Home => scroll direct
    if (location.pathname === "/espace") {
      doScroll();
      return;
    }

    // Sinon => je navigue vers Home, puis je scroll après rendu
    navigate("/espace", { replace: false });
    setTimeout(doScroll, 0);
  };

  useEffect(() => {
    const onDocClick = (e) => {
      if (!userRef.current) return;
      if (!userRef.current.contains(e.target)) setOpenUser(false);
    };
    document.addEventListener("mousedown", onDocClick);
    return () => document.removeEventListener("mousedown", onDocClick);
  }, []);

 
  const displayName = user?.displayName || user?.name || user?.codtiers || "Mon compte";

  const goAccount = () => {
    setOpenUser(false);
    navigate("/account");
  };
  const doLogout = async () => {
    setOpenUser(false);
    logout();
    navigate("/login", { replace: true });
  };
  return (
    <header className={`hdr hdr--${brand} ${scrolled ? "is-scrolled" : ""}`}>
      <div className="hdr__inner">

        {/* GAUCHE (blanc) */}
        <div className="hdr__left">
          <a href="/espace" className="brand" aria-label="Accueil">
            <img
              src={brand === "mg" ? mgLogo : amenLogo}
              alt="Logo"
              className="brand__img"
            />
          </a>

          <div className="hdr__titles">
            <div className="hdr__title">Amen &amp; MG</div>
            <div className="hdr__subtitle">Piéces Automobiles B2B</div>
          </div>

          <div className="company-select">
            <select
              aria-label="Sélection société"
              value={brand}
              onChange={(e) => setBrand(e.target.value)}
              className={`company-select__input company-select__input--${brand}`}
              // couleur du texte selon la valeur sÃ©lectionnÃ©e
              style={{ color: brand === "amen" ? "#7a0f18" : "#2563eb" }}
            >
              <option value="amen" style={{ color: "#7a0f18" }}>
                Amen Distributions
              </option>
              <option value="mg" style={{ color: "#2563eb" }}>
                MG Distributions
              </option>
            </select>
            <span className="company-select__chev"></span>
          </div>

        </div>

        {/* DROITE (fond colorÃ©) */}
        <div className="hdr__right">

          {/* IcÃ´nes + libellÃ©s en colonne (exactement comme sur la capture) */}
          <nav className="nav" aria-label="Navigation principale">
            <button
  type="button"
  className="nav__item"
  aria-label="Accueil"
  onClick={() => scrollToSection("page-top")}
  style={{ background: "transparent", border: "none", cursor: "pointer" }}
>
  <FaHome className="nav__icon" />
  <span className="nav__label">Accueil</span>
</button>

            <button
              type="button"
              className="nav__item nav__item--notif"
              aria-label="Produits"
              onClick={scrollToProducts}
              style={{ background: "transparent", border: "none", cursor: "pointer" }}
            >
              <img src={iconProducts} alt="" className="nav__icon" />
              <span className="nav__label">Products</span>
            </button>

            <button
              type="button"
              className="nav__item"
              onClick={() => scrollToSection("footer-section")}
              style={{ background: "transparent", border: "none" }}
            >
              <img src={iconAide} alt="" className="nav__icon" />
              <span className="nav__label">24/7 Aide</span>
            </button>



            <Link to="/pannier" className="nav__item nav__item--notif"
              aria-label={`Panier${cartCount ? ` (${cartCount} article${cartCount > 1 ? "s" : ""})` : ""}`}>
              <span className="nav__cartWrap">
                <CartIcon className="nav__icon" />
                {cartCount > 0 && (
                  <span key={cartCount} className="nav__badge">{cartCount > 99 ? "99+" : cartCount}</span>
                )}
              </span>
              <span className="nav__label">Panier</span>
            </Link>
            <div ref={userRef} className="nav__item nav__item--user">
              <button
                type="button"
                className="user-btn"
                aria-haspopup="menu"
                aria-expanded={openUser}
                onClick={() => setOpenUser((v) => !v)}
              >
                <img src={iconUser} alt="" className="nav__icon" />
                <span className="nav__label">{displayName}</span>

              </button>

              {openUser && (
                <div className={`user-menu user-menu--${brand}`} role="menu">
                  <button className="user-menu__item" role="menuitem" onClick={goAccount}>
                    Mon compte
                  </button>
                  <button className="user-menu__item danger" role="menuitem" onClick={doLogout}>
                    Déconnexion
                  </button>
                </div>
              )}
            </div>
          </nav>
        </div>
      </div>
    </header>
  );
}
// place ceci en bas du fichier (avec les autres icÃ´nes si tu veux)
const CartIcon = ({ size = 26, className = "" }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden
  >
    <circle cx="9" cy="21" r="1" />
    <circle cx="20" cy="21" r="1" />
    <path d="M1 1h4l2.68 12.39a2 2 0 0 0 2 1.61H19a2 2 0 0 0 2-1.61L23 6H6" />
  </svg>
);


